import React from 'react';
import { ReactComponent as PromptLogo } from '../../assets/prompt-logo.svg';
import { ReactComponent as PromptLogo2 } from '../../assets/prompt-logo-2.svg';

export default function PromptSection() {
  return (
    <section id='prompt' className='flex items-center justify-center my-26'>
      <div className='max-w-5xl mx-auto px-6 lg:px-0'>
        <div className='flex flex-col md:flex-row md:gap-6 gap-14 items-start'>
          <div className='space-y-4 w-full max-w-[23.125rem] md:text-left text-center mx-auto'>
            <h2 className='text-4.5xl font-semibold leading-[141%]'>
              What is Prompt?
            </h2>
            <p className='text-white/60 text-lg md:text-base'>
              Prompt is the native token of the Wayfinder platform, used for
              transactions, gas fees, and unlocking premium features.
            </p>
          </div>

          <div className='flex gap-4 text-base md:text-13 sm:flex-row flex-col text-base md:text-13'>
            <div className='md:h-[12.875rem] h-[16.438rem] flex flex-col justify-between p-4 rounded-2xl bg-gradient-to-r from-white/3 via-white/5 to-white/3'>
              <PromptLogo className='w-14 h-14' />
              <div>
                <h3 className='text-white font-semibold mb-2'>Token</h3>
                <p className='text-gray leading-relaxed'>
                  $PROMPT is the ERC-20 governance and utility token powering
                  the AI-driven Wayfinder ecosystem.
                </p>
              </div>
            </div>

            <div className='md:h-[12.875rem] h-[16.438rem] flex flex-col justify-between p-4 rounded-2xl bg-gradient-to-r from-white/3 via-white/5 to-white/3'>
              <PromptLogo2 className='w-14 h-14' />

              <div>
                <h3 className='text-white font-semibold mb-2'>Application</h3>
                <p className='text-gray leading-relaxed'>
                  Wayfinder's token powers shells, fuels gas, enables staking,
                  funds services, and governs the ecosystem.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
